import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

interface Props {
  open: boolean;
  title: string;
  stages: string[];
  testId?: string;
}

export const ProcessingOverlay: React.FC<Props> = ({ open, title, stages, testId }) => {
  const [step, setStep] = useState(0);
  const [pct, setPct] = useState(0);

  useEffect(() => {
    if (!open) { setStep(0); setPct(0); return; }
    const stepTimer = setInterval(() => setStep((s) => Math.min(s + 1, stages.length - 1)), 650);
    const pctTimer = setInterval(() => setPct((p) => Math.min(p + Math.random() * 12, 94)), 180);
    return () => { clearInterval(stepTimer); clearInterval(pctTimer); };
  }, [open, stages.length]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid={testId}>
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />
      <div className="relative z-10 w-full max-w-md rounded-xl border border-primary/30 bg-card p-6 shadow-2xl">
        <div className="flex items-center gap-3">
          <Loader2 className="h-5 w-5 animate-spin text-primary" />
          <h3 className="text-lg font-semibold">{title}</h3>
        </div>
        <div className="mt-5 h-2 overflow-hidden rounded-full bg-secondary">
          <div className="h-full bg-gradient-to-r from-primary to-emerald-400 transition-all duration-200" style={{ width: `${pct}%` }} />
        </div>
        <div className="mt-2 text-right font-mono text-xs text-muted-foreground">{Math.round(pct)}%</div>
        <ul className="mt-4 space-y-2">
          {stages.map((s, i) => (
            <li key={s} className={`flex items-center gap-2 text-sm transition-opacity ${i <= step ? "opacity-100" : "opacity-35"}`}>
              <span className={`h-2 w-2 rounded-full ${i < step ? "bg-emerald-400" : i === step ? "bg-primary animate-pulse" : "bg-slate-600"}`} />
              <span className={i === step ? "text-foreground" : "text-muted-foreground"}>{s}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
